import React from 'react';
import PropTypes from 'prop-types';

function FormInputAdditionalDescription(props) {
  const getParagraphs = (str) => {
    return str.split('<br>').map(paragraph => (

      <>
        {paragraph}
        <br />
      </>
    ));
  };

  return (
    <span id={props.id} className="form-field-wrapper__input-additional-description">
      {getParagraphs(props.additionalDescription)}
    </span>
  );
}

FormInputAdditionalDescription.propTypes = {
  id: PropTypes.string.isRequired,
  additionalDescription: PropTypes.string.isRequired,
};

export default FormInputAdditionalDescription;
